import { render, staticRenderFns } from "./cd-dataview.vue?vue&type=template&id=40cfa4ec"
import script from "./cd-dataview.vue?vue&type=script&lang=js"
export * from "./cd-dataview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports